<script setup lang="ts">
import { defineAsyncComponent } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useLegalConsentStore } from '@/stores/legalConsent'
import { onAuthStateChanged } from 'firebase/auth'
import { auth } from '@/services/firebase/config'

/**
 * Diálogo del consentimiento legal (ADR-SEC-018): uno solo para toda la app,
 * gobernado por el store. Se carga en DIFERIDO y sólo cuando hace falta: si se
 * importa estático, el bundler reparte el SDK de Firebase y
 * `src/services/firebase/config.ts` en un chunk aparte del entry, y la aserción
 * post-build de `scripts/deploy/hosting.sh` (ADR-022) —que exige que el entry
 * nombre al proyecto del entorno— no publica (medido 2026-10-04).
 */
const LegalConsentModal = defineAsyncComponent(
  () => import('@/components/auth/LegalConsentModal.vue')
)

const authStore = useAuthStore()
const legalConsent = useLegalConsentStore()

// Keep auth store in sync with Firebase Auth state changes (login, logout, token refresh)
onAuthStateChanged(auth, (user) => {
  authStore.setUser(user)
})
</script>

<template>
  <router-view />
  <LegalConsentModal v-if="legalConsent.required" />
</template>

<style>
/* Global styles are imported in main.ts */
</style>
